import getContent from 'pp-react-l10n';
import React from 'react';

export default (page, property, defaultValue, opts = {}) => {
  // when useHTML = true, content will return a react component
  const { useHTML = false, params = null } = opts;
  const content = getContent(page)(property, params, { useHTML });
  if (
    typeof content === 'string' ||
    Array.isArray(content) ||
    React.isValidElement(content)
  ) {
    return content;
  }
  return defaultValue;
};
